import { Controller } from '@hotwired/stimulus'
import consumer from '~/channels/consumer'

// Live-updates the coach web chat thread. Subscribes to the existing
// ConversationChannel (server enforces the coach is a participant).
export default class extends Controller {
  static targets = ['messages']

  static values = { conversationId: String, currentUserId: String }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: 'ConversationChannel', conversation_id: this.conversationIdValue },
      { received: (data) => this.handleEvent(data) }
    )
    this.scrollToBottom()
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleEvent(data) {
    if (data.event !== 'new_message') return
    // Our own sends arrive via the redirect re-render; only append others' messages.
    if (String(data.message.sender_id) === this.currentUserIdValue) return
    this.appendMessage(data.message)
  }

  appendMessage(message) {
    const wrapper = document.createElement('div')
    wrapper.className = 'max-w-[75%]'
    const time = new Date(message.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    wrapper.innerHTML = `
      <div class="inline-block px-3 py-2 text-sm border-2 border-neutral-900 bg-white"></div>
      <div class="text-[10px] text-slate-400 mt-0.5">${time}</div>
    `
    wrapper.querySelector('div').textContent = message.content // textContent: no HTML injection
    this.messagesTarget.appendChild(wrapper)
    this.scrollToBottom()
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
